/**
 * Calculate age from date of birth
 * @param {string} dob - Date of birth in ISO format
 * @returns {number|null} Age in years or null if invalid date
 */
export const calculateAge = (dob) => {
  if (!dob) return null;
  
  const birthDate = new Date(dob);
  if (isNaN(birthDate.getTime())) return null;
  
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

/**
 * Calculate distance between two points using Haversine formula
 * @param {Array} userLocation - User location as [longitude, latitude]
 * @param {Object} profileLocation - Profile location in GeoJSON format
 * @returns {number|null} Distance in kilometers or null if invalid coordinates
 */
export const calculateDistance = (userLocation, profileLocation) => {
  if (!userLocation || !profileLocation || !profileLocation.coordinates) return null;
  
  const [lon1, lat1] = userLocation;
  const [lon2, lat2] = profileLocation.coordinates;
  
  if (!lat1 || !lon1 || !lat2 || !lon2) return null;
  
  const R = 6371; // Earth's radius in kilometers
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
           Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
           Math.sin(dLon/2) * Math.sin(dLon/2);
  
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  const distance = R * c;
  
  return Math.round(distance);
};
